
import Vue from 'vue'

export default Vue.extend({
  computed:{
    nextAvailableStock(): string{
      return this.$store.getters.product.next_available_date_info
    }
  }
})
